import { useVertiportClusters } from '@components/map/layers/vertiports/useVertiportClusters';
import { clusterIconLayer, fatoIconLayer } from '@components/map/layers/vertiports/vertiport.layer';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectVertiportFeatures } from '@redux/intercom/intercom.selector';
import { FeatureCollection, GeoJsonProperties } from 'geojson';
import { Layer, Source } from 'react-map-gl/mapbox';
import { PointFeature } from 'supercluster';

import { SourceNameEnum } from '@/types/map.types';

export function VertiportLayer() {
  const vertiportFeatures = useAppSelector(selectVertiportFeatures);

  const pointFeatures: PointFeature<GeoJsonProperties>[] = vertiportFeatures.features.filter(
    (feature): feature is PointFeature<GeoJsonProperties> => feature.geometry.type === 'Point',
  );

  const clustersWithImage = useVertiportClusters(pointFeatures);

  const features: FeatureCollection = {
    type: 'FeatureCollection',
    features: clustersWithImage,
  };

  return (
    <Source id={SourceNameEnum.VERTIPORTS} type="geojson" data={features} tolerance={0} maxzoom={23}>
      <Layer {...clusterIconLayer} />
      <Layer {...fatoIconLayer} />
    </Source>
  );
}
